import React from "react"

export const BodyTextAst = ({ children }) => (
  <p className="leading-loose text-lg text-left mb-8">{children}</p>
)
